import { z } from "zod";

export const notEmptyStringSchema = z
  .string()
  .trim()
  .min(1, { message: "common.validation.required" });
